<template>
  <div class="brand-mark" :class="{ compact }">
    <div class="brand-mark__orb"></div>

    <svg viewBox="0 0 88 88" class="brand-mark__svg" aria-hidden="true">
      <defs>
        <linearGradient id="bhGradient" x1="0" x2="1" y1="0" y2="1">
          <stop offset="0%" stop-color="#ff5d37" />
          <stop offset="100%" stop-color="#8f6bff" />
        </linearGradient>
      </defs>

      <image href="@/assets/logo-main.svg" x="9px" y="9px" height="70" width="70"></image>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'BrandMark',
  props: {
    compact: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped src="./BrandMark.css"></style>
